<template>
  <div id="app">
    <Header></Header>
    <router-view></router-view>
    <Footer></Footer>
  </div>
</template>

<script>
import router from '@/router'
import { getLanguage } from '@/util/lang'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
export default {
  name: 'App',
  components: {
    Header,
    Footer
  },
  created() {
    this.init()
  },
  methods: {
    init() {      
      const lang = getLanguage()
      if (lang != null) {
        this.$i18n.locale = `${lang}`;
        this.$store.dispatch('setCurrentLanguage', `${lang}`)
        // 添加时间戳作为查询参数，强制路由更新
        router.push({ path: router.currentRoute.path, query: { t: Date.now() } })
      }
    }
  }
}
</script>

<style lang="scss">
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}
</style>
